/**
 * ✅ Caché simple en memoria para shipments
 * Almacena datos con TTL (Time To Live)
 */

interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

class SimpleCache {
  private cache = new Map<string, CacheEntry<any>>();
  
  set(key: string, data: any, ttlMs: number = 5 * 60 * 1000) {
    this.cache.set(key, {
      data,
      timestamp: Date.now() + ttlMs
    });
  }
  
  get(key: string) {
    const entry = this.cache.get(key);
    
    if (!entry) return null;
    
    // Verificar si expiró
    if (Date.now() > entry.timestamp) {
      this.cache.delete(key);
      return null;
    }
    
    return entry.data;
  }
  
  clear(keyPattern?: string) {
    if (keyPattern) {
      // Limpiar keys que coincidan con el patrón
      for (const key of this.cache.keys()) {
        if (key.includes(keyPattern)) {
          this.cache.delete(key);
        }
      }
    } else {
      this.cache.clear();
    }
  }
  
  getSize() {
    return this.cache.size;
  }
}

export const simpleCache = new SimpleCache();
